import React from 'react';

export function BlinkDot({
    height = 16,
    width = 16,
    marginLeft = 0,
    backgroundColor = 'green-400',
    textColor = '#191D3A',
}: {
    height?: number;
    width?: number;
    marginLeft?: number;
    backgroundColor?: Color;
    textColor?: string;
}) {
    const h = `${height}px`;
    const w = `${width}px`;
    const colorClass = `bg-${backgroundColor}`;
    const borderRadius = `${height / 2}px`;
    return (
        <div
            style={{
                display: 'inline-block',
                height: h,
                width: w,
                borderRadius: borderRadius,
                marginLeft: `${marginLeft}px`,
                color: textColor,
            }}
            className={colorClass}
        />
    );
}

type Color = 'green-400' | 'green-100' | 'green-200' | 'blue-alt-900' | 'bluegray-200' | 'blue-alt-800';
